import { put } from '.';

export function UpdateVehicle(id, options = {}) {
	return put<any>("/app/api/vehicles/" + (id || 0).toString(), options);
}
